import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import BetaIcon, { IconSizes } from './Icons/Icon';
import classNames from 'classnames';
import { useMatchesMinWidth } from '../hooks/useMatchesMinWidth';
import { BREAKPOINTS } from '../../constants';
import Drawer from '../ui-components/Drawer/Drawer';
import { CustomIconOption } from './Select/SelectCustomOptions';

const ActionSelect = ({ options, actions, placeholder, className }) => {
  const defaultValue = null;
  const [selectedOption, setSelectedOption] = useState(defaultValue);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const isDeviceSmallerThanMblLandscape = !useMatchesMinWidth(BREAKPOINTS.MBL_LANDSCAPE);

  const handleChange = (selectedOption) => {
    if (actions[selectedOption.value]) {
      actions[selectedOption.value]();
    }
    setSelectedOption(defaultValue);
    setIsDrawerOpen(false);
  };

  const renderDesktopSelect = () => (
    <Select
      isSearchable={false}
      placeholder={placeholder}
      value={selectedOption}
      classNamePrefix={className}
      options={options}
      onChange={handleChange}
      inputProps={{ readOnly: true }}
      components={{
        IndicatorSeparator: () => null,
        Option: (props) => (<CustomIconOption {...props} />),
        DropdownIndicator: ({ selectProps }) => {
          const isOpen = selectProps.menuIsOpen;
          return (
            <BetaIcon name={isOpen ? "chevronUp" : "chevronDown"} size={IconSizes[20]} />
          );
        },
      }}
    />);

  const renderMobileSelect = () => (
    <>
      <div className="entry__cta__control d-flex items-center" onClick={() => setIsDrawerOpen(true)}>
        <span className="entry__cta__placeholder">{placeholder}</span>
        <BetaIcon name="chevronDown" size={IconSizes[20]} />
      </div>

      <Drawer
        classNames={'drawer--content-fit'}
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        title={placeholder}
        body={
          <>
            {options.map((option) => (
              <div
                key={option.value}
                className="d-flex items-center gap-base p-3xs pointer"
                onClick={() => handleChange(option)}
              >
                <BetaIcon name={option.icon} size={IconSizes[16]} style={{ marginRight: 8 }} />
                {option.label}
              </div>
            ))}
          </>
        }
      />
    </>
  );

  return isDeviceSmallerThanMblLandscape ? renderMobileSelect() : renderDesktopSelect();
};

ActionSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.string,
    })
  ).isRequired,
  actions: PropTypes.objectOf(PropTypes.func).isRequired,
  placeholder: PropTypes.string,
};

export default ActionSelect;
